app.service('paymentView', function (front, loading, validate, orderConfig, loginModal, keycloak,
	paymentOperator, scroll, paymentBox, orderUtils, holidayPromotion, broker, modal, giftCardPaymentType,
	unavailableItemsModal, console, message, kredytLineRedirect, log, orderPath) {
	var $self, $form, config;
	var warrantyConflictModalClosedfromButton = false;
	let isOneInit = false;
	let resolveSubscriptionAfterChangePayment = false;

	function paymentValidateServices() {
		return $.ajax({
			url: '/order-path-adjust-services-in-order.ltr',
			type: 'POST',
			dataType: 'json'
		});
	}

	function showValidationErrorMessage() {
		loading.stop();
		modal.alert('Wystąpił błąd walidacji. Prosimy odświeżyć stronę i spróbować jeszcze raz');
	}

	function paymentValidationSuccess(json) {
		if (json.status !== 'SUCCESS') {
			loading.stop();
			modal.generate({
				id: 'modal-payment-validation',
				content: json.messages.join('<br />'),
				buttons: [{
					text: 'Rozumiem',
					cssClass: 'btn-second js-close-modal'
				}]
			});
			return false;
		}
		send(config.nextAction);
	}

	function validateServicesAndContinue() {
		paymentValidateServices()
			.then(paymentValidationSuccess)
			.fail(showValidationErrorMessage);
	}

	function validateOrderAfterOrderPayment() {
		return $.ajax({
			url: 'order-path-validateOrderAfterOrderPaymentEdit.ltr',
			dataType: 'json'
		})
			.fail(() => modal.alert('Wystąpił błąd walidacji. Prosimy odświeżyć stronę i spróbować jeszcze raz'));
	}

	function requiresAddressConfirmation() {
		return config.paymentCode === 12 // raty
			|| config.paymentCode === 28; // leasing
	}

	function next() {
		if (config.paymentCode === 16) {
			if (!giftCardPaymentType.valid()) {
				return;
			}
		}
		if (requiresAddressConfirmation() && !$('#address-reminder').hasClass('checked')) {
			$('#address-reminder').addClass('error');
			scroll.to({ $element: $('#address-reminder') });
			UA.interaction('Proces ratalny', 'Walidacja', 'Blad Walidacji');
			return;
		}
		if (unavailableItemsModal.checkStatus()) {
			return;
		}
		resolveSubscriptionAfterChangePayment = false;
		if ($form.valid()) {
			loading.start();
			if (config.containsAnyPostponedWarrantyPayment || config.containsAnySubscriptionWarrantyPayment) {
				validateOrderAfterOrderPayment()
					.then(data => {
						console.log(data)
						if (data.status === "FAIL") {
							showResolveWarrantyPaymentConflictEncouragement(false);
						} else {
							validateServicesAndContinue();
						}
					});
			} else {
				validateServicesAndContinue();
				return false;
			}
		}
	}

	function showResolveWarrantyPaymentConflictEncouragement() {
		loadResolveWarrantyPaymentConflictEncouragement()
			.then(html => {
				var callbackCloseCount = 0;
				modal.generate({
					id: 'warranty-payment-conflict-encouragement',
					content: html,
					callbackClose: function () {
						callbackCloseCount += 1;
						if (callbackCloseCount == 1 && warrantyConflictModalClosedfromButton === false) {
							//FIX zabezpieczający przed ponownym nakładaniem zdarzeń dla callbackClose 
							//TODO EURSI-30565 do poprawienia w modal.js zdarzenie z callbackClose, aby nie nakładało zdarzeń ponownie.
							UA.interaction('PG ABO na Raty', 'Kliknięcie', 'Powrót');
						}
					},
					callbackOpen: function () {
						UA.interaction('PG ABO na Raty', 'Wyświetlenie', 'Popup');
					}
				});
			});
	}

	function showRecurringPaymentsEncouragementModal(content) {
		modal.generate({
			id: 'recurring-payments-encouragment-modal',
			content: content,
			buttons: [{
				text: 'Rozumiem',
				cssClass: 'btn-second',
				click: function () {
					modal.close();
				}
			}]
		});
	}

	function loadResolveWarrantyPaymentConflictEncouragement() {
		return $.ajax({
			url: '/order-path-resolve-warranty-payment-conflict-encouragement.ltr'
		}).fail(() => {
			modal.alert('Wystąpił błąd ładowania gwarancji. Odśwież stronę i spróbuj ponownie.')
		});
	}

	function send(action) {
		orderUtils.send(action);
	}
	function back() {
		orderUtils.back();
	}
	function checkSplitPaymentMessage() {
		if ($('.js-split-payment-message').length) {
			modal.generate({
				id: 'modal-split-payment-message',
				content: $('.js-split-payment-message').html(),
				buttons: [
					{
						text: 'Rozumiem',
						cssClass: 'btn-second js-close-modal'
					}
				]
			});
		}
	}

	function resolveSubscriptionWarrantyPaymentConflict() {
		function closeModalWarranty() {
			modal.close();
			loading.reload({ soft: true });
		}
		if (allRequiredWarrantyOptionsSelected()) {
			const requestData = $('.product-warranty-options').map(createRequestData);
			resolveSubscriptionWarrantyPaymentConflictRequest(JSON.stringify({ changePayment: resolveSubscriptionAfterChangePayment, warrantiesToUpdate: requestData.toArray() }))
				.then(() => resolveSubscriptionAfterChangePayment ? closeModalWarranty() : validateServicesAndContinue())
				.fail(() => modal.alert('Wystąpił błąd przetwarzania. Prosimy odświeżyć stronę i spróbować jeszcze raz.'));
		}
	}

	function allRequiredWarrantyOptionsSelected() {
		let isValid = true;

		$('.product-warranty-options').each(function () {
			let $selectedOption = $(this).find('input[name^=warranty-id]').filter(":checked");

			if (!$selectedOption.length) {
				isValid = false;
				$(this).parents('.product-warranty-wrapper').addClass('error');
			}
		});

		return isValid;
	}

	function createRequestData() {
		const warrantyId = $(this).find('input[name^=warranty-id]').filter(':checked').val();
		warrantyConflictModalClosedfromButton = true;
		UA.interaction('PG ABO na Raty', 'Kliknięcie', warrantyId == '' ? 'Rezygnacja z PG' : 'Proponowany PG');

		if (!warrantyId || warrantyId === "0") return;

		const productId = $(this).find('input[name^=product-id]').val();
		const suiteCode = $(this).find('input[name^=suite-code]').val();

		return {
			productId,
			suiteCode,
			warrantyId
		};
	}

	function resolveSubscriptionWarrantyPaymentConflictRequest(data = {}) {
		return $.ajax({
			url: "/order-path-resolve-warranty-payment-conflict.ltr",
			type: "POST",
			contentType: 'application/json',
			data
		});
	}

	function setElements() {
		$self = $('#payment #container');
		$form = $('form', $self);
		config = orderConfig.getData();
	}
	function setEvents() {
		if (history.scrollRestoration && /Chrome/.test(window.navigator.userAgent)) {   //wylaczenie 'scroll restoration' dla chrome - zapobiega przewijaniu zawartosci strony do dołu
			history.scrollRestoration = 'manual';
		}
		$self.on('click', '.js-payment-back', function () {
			back();
		});
		$('.js-show-all-payments', $self).on('click', function () {
			$form.find('.payment-list .radio-group').addClass('show-all');
		});
		$('.js-back-to-k3', $self).on('click', function () {
			UA.interaction('Proces ratalny', 'Link', 'Zmiana adresu dostawy');
			const deliveryBackTo = $(this).data('delivery-back-to'); // 'delivery-point' albo 'delivery-details'
			const $backTo = $(`#preview-order-steps .row-${deliveryBackTo} .back`);
			if ($backTo.length) { // do posprzątania przy usuwaniu testu ajaksowej ścieżki
				$backTo[0].click();
			} else {
				back();
			}
		});
		$('.js-address-checked', $self).on('click', function () {
			$('#address-reminder').removeClass('error').toggleClass('checked');
		});
		$('.js-cancel-payment-giftcard').on('click', function () {
			$('input, select, textarea', $(this).closest('form')).ignore(true);
			send('RESET_GIFT_CARD_PAYMENT');
		});
		validate.task('payment');
		if (!isOneInit) {
			isOneInit = true;
			broker.on('BLOCK_PAYMENT_TYPE', function () {
				$self.addClass('block-payment-type')
			});
			broker.on('UNBLOCK_PAYMENT_TYPE', function () {
				$self.removeClass('block-payment-type')
			});
			broker.on('ORDER-NEXT-STEP', function () {
				if ($('.js-payment-next').length && orderConfig.getData().pageType == 'payment') {		// nie może być samo config, tutaj trzeba pobrać dane w tym momencie
					next();
				}
			});
			$('body').on('click', '.js-resolve-warranty-payment-conflict',
				resolveSubscriptionWarrantyPaymentConflict
			).on('change', '.product-warranty-options input[name^=warranty-id]', function validateWarrantyOptions() {
				$(this).parents('.product-warranty-wrapper').removeClass('error');
			}).on('click', '.js-payment-next', function () {
				next();
			}).on('click', '.js-guest-login', function () {
				const paymentType = $(this).closest('.payment-item').find('.js-payment-type').val();
				const paymentName = $(this).data('payment-name');
				const buttonText = $(this).text().trim();
				guestLoginClick({
					paymentType, paymentName, buttonText
				});
			}).on('click', '.js-guest-register', function (e) {
				const paymentType = $(this).closest('.payment-item').find('.js-payment-type').val();
				const paymentName = $(this).data('payment-name');
				const buttonText = $(this).text().trim();
				guestRegisterClick({
					paymentType, paymentName, buttonText
				});
			}).on('click', '.js-recurring-payments-encouragment', function () {
				message.get('order-payment.bhtml - recurring_payments_encouragment - modal').then(function (content) {
					showRecurringPaymentsEncouragementModal(content);
				});
			}).on('click', '.js-recurring-payments-encouragment-blik', function () {
				message.get({ url: 'orderPaymentBlikRecurringModal.ltr' }).then(function (content) {
					showRecurringPaymentsEncouragementModal(content);
				});
			}).on('click', '.js-creditline-redirect', function () {
				const orderNumber = $(this).data('order-number');
				log.event({
					id: 'creditline_application_ongoing',
					f03: 'order-payment',
					f04: 'kliknięcie przycisku dokończ wniosek',
				});
				kredytLineRedirect.redirect({
					orderNumber
				}, {
					timeout: config.nklTimeout,
					revisions: config.nklRevisions
				});
			});
		}
		if (testAB.getVar('ajax-order2') !== 'B') {
			if (location.hash == '#edit-payment') {
				scroll.to({ $element: $('form') });
			}
		}
	}
	function guestRegisterClick({ paymentType, paymentName, buttonText }) {
		if (config.keycloakEnabled) {
			keycloak.redirect({ url: '/order-register.bhtml?paymentTypeCode=' + paymentType, buttonText });
		} else {
			loginModal.load({
				type: 'registration',
				paymentName: paymentName,
				callbackAfterSuccess: function () {
					broker.trigger('SELECT_PAYMENT_TYPE', paymentType);
				}
			});
		}
	}
	function guestLoginClick({ paymentType, paymentName, buttonText }) {
		if (config.keycloakEnabled) {
			keycloak.redirect({ url: '/order-login.bhtml?paymentTypeCode=' + paymentType, buttonText });
		} else {
			loginModal.load({
				type: 'login-guest',
				paymentName: paymentName,
				callbackAfterSuccess: function () {
					broker.trigger('SELECT_PAYMENT_TYPE', paymentType);
				}
			});
		}
	}

	function init() {
		setElements();
		setEvents();
		checkSplitPaymentMessage();
		if (front.euro) {
			giftCardPaymentType.init(paymentBox.sendNewPaymentType);
		}
		unavailableItemsModal.init();
		paymentBox.init(function (json) {
			$(".js-payment-next").html(json.nextButton);
			let $box = $('#preview-list');
			$box.html(json.previewRight);
			let $box2 = $('#preview-order-steps');
			$box2.html(json.previewLeft);
			holidayPromotion.refresh();
			paymentOperator.change(json.paymentOperator, json.paymentOperatorRegulationUrl);
			resolveSubscriptionAfterChangePayment = false;
			if (config.paymentCode == 16) {
				$('#gift-card-amount-to-cover').html(' ' + json.giftCardAmountToCoverBySupplementPayment);
			} else if ((config.paymentCode == 12 || config.paymentCode == 5) && (config.containsAnyPostponedWarrantyPayment || config.containsAnySubscriptionWarrantyPayment)) {
				resolveSubscriptionAfterChangePayment = true;
				showResolveWarrantyPaymentConflictEncouragement();
			}
			$box.attr('wdio-ready', parseInt(Math.random() * 1000000000));
			orderPath.reload(json.orderPathStage);
		});
		paymentOperator.init();


	}
	return {
		init
	};
});
